import React, { useState, useContext } from 'react';
import logo from "../assets/medicare-club-logo.svg";
import {
  FaReceipt,
  FaBan,
  FaInfo,
  FaTrash,
  FaGift,
  FaAngleRight,
  FaCamera,
  FaHeadset
} from "react-icons/fa";
import {
  Button,
  Modal,
  Row,
  Col,
  Spinner,
  Badge,
  Accordion,
  Card,
  Form,
  Alert,
  InputGroup,
  FormControl
} from 'react-bootstrap';
// import Loader from 'react-loader-spinner';
import { CustomerService } from "../services/customer-service";
import { OffersService } from "../services/offers-service";
import QrReader from 'react-qr-reader';
import { FiGrid } from "react-icons/fi";
import Menu from "../components/Menu";
import { UserContext } from "../context/UserContext";

import clubCardsImg from '../assets/clubcards.png';
import medicareCardsImg from '../assets/medicarecards.png';


import {
  HomePage, HomeContent, HomeBody, Search, DiscountInfo, OfferInfo, ButtonSearch, Result,
  ResultInfo, ButtonClear
} from "../styles";

import Toast from 'light-toast';

let customer;
function Home() {
  const [user] = useContext(UserContext);
  const [offers, setOffers] = useState([]);
  const [alerModal, setAlertModal] = useState(false);
  const [offersChecked, setOffersChecked] = useState([]);
  const [amounts, setAmounts] = useState({
    amount_with_discount: "",
    amount_without_discount: ""
  });

  const [aActived, setaActived] = useState(null);

  function onConfirm(offer_id, index) {
    const existIndex = offersChecked.findIndex((offer) => { return offer.offer_id === offer_id });
    if (existIndex >= 0) {
      let aux = offersChecked;
      aux.splice(existIndex, 1);
      setOffersChecked(aux);
      if (aActived === null) { setaActived(""); }
      if (aActived === "") { setaActived(null); }
    } else {
      const el = {
        offer_id: offer_id
      };
      setOffersChecked([...offersChecked, el]);
      setaActived(null);
    }
  }

  function cardClicked(item) {
    if (aActived === item.offer_id) {
      setaActived(null);
    } else {
      setaActived(item.offer_id);
    }
  }

  function offerDate(start, end) {
    let startdate = "XX-XX-XXXX";
    let enddate = "XX-XX-XXXX";
    if (start) {
      const s = start.substring(0, 10).split('-');
      startdate = s[2] + '-' + s[1] + '-' + s[0];
    }
    if (end) {
      const s = end.substring(0, 10).split('-');
      enddate = s[2] + '-' + s[1] + '-' + s[0];
    }
    return startdate + ' - ' + enddate;
  }

  let listItems = offers.map((item, index) => {
    let alertMessage;
    if (item.can_use === "0" && item.is_medicare === "1"
      && item.is_not_medicare === "0" && customer?.customer_group_id === "1") {
      alertMessage = <Alert size="sm" variant="danger">Membro <strong>Base</strong> sem acesso a esta oferta.</Alert>;
    } else if (item.can_use === "0") {
      alertMessage = <Alert size="sm" variant="danger">Oferta não disponível para este cliente.</Alert>;
    }

    return (
      <Card key={item.offer_id}>
        <Card.Header>
          <div className="discount_top"><h3>{item.title}</h3></div>
          {item.can_use === "1" ?
            <Form.Check type="checkbox" onClick={() => onConfirm(item.offer_id, index)} label="" /> : <FaBan size={25} color="#BF2F38" />}
          {/* {item.can_use === "0" ? <FaBan size={25} color="#BF2F38" /> : null} */}
        </Card.Header>
        <Card.Body>
          <div className="header_bottom">
            <DiscountInfo>
              {item.offer_type_id === "3" ?
                <h3><FaGift /></h3>
                : null}
              {item.offer_type_id === "2" ?
                <div>
                  <span className="money">{item.discount}</span>
                  <span className="ao"> Kz</span>
                </div>
                : null}
              {item.offer_type_id === "1" ? <div><span className="money">{item.discount}</span>% </div> : null}

              {/* {item.is_medicare === "1" && item.is_not_medicare === "0" ? <p className="label exclusivo">Exclusivo</p> : <p className="base">Base</p>} */}
              {item.is_medicare === "1" && item.is_not_medicare === "0" ? <span className="badge exclusivo">Exclusivo</span> : null}
            </DiscountInfo>
            <FaInfo className="viewMore" onClick={(e) => cardClicked(item)} />
          </div>

          <Accordion.Collapse eventKey={item.offer_id}>
            <div>
              <Row>

                <Col>
                  <hr />
                  <OfferInfo>

                    <div className="others">
                      <span className="days">
                        {item.valid_weekday_0 === "1" ? "Seg |" : null}
                        {item.valid_weekday_1 === "1" ? " Ter |" : null}
                        {item.valid_weekday_2 === "1" ? " Qua |" : null}
                        {item.valid_weekday_3 === "1" ? " Qui |" : null}
                        {item.valid_weekday_4 === "1" ? " Sex |" : null}
                        {item.valid_weekday_5 === "1" ? " Sáb |" : null}
                        {item.valid_weekday_6 === "1" ? " Dom" : null}
                        <br />
                        {offerDate(item.date_in, item.date_out)}
                      </span>

                    </div>
                  </OfferInfo>
                  <div className="text-description" dangerouslySetInnerHTML={{ __html: item.description }} ></div>
                </Col>
              </Row>
              {alertMessage}
            </div>
          </Accordion.Collapse>
        </Card.Body>
      </Card>
    )
  });

  const [load, setLoad] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [data, setData] = useState({
    phone_number: "",
    card_number: "",
  });
  const [cardNumber,setCardNumber]=useState('')
  const [result, setResult] = useState(null);

  function dataChange(event) {
    const fieldName = event.target.getAttribute('name');
    const { value } = event.target;
    setData({
      ...data,
      [fieldName]: value,
    });
  }

  async function searchClick(e = null) {
    if (e) {
      e.preventDefault();
    }
    onClear(false);
    if(cardNumber.length<9){
      Toast.fail('O Número de Cartão deve ter no minimo 9 digitos', 3000);
      return null;
    }
    setLoad(true);
    let param = cardNumber
    if (param) {
      CustomerService.validate_customer(user.token, user.provider_id, user.location_id, cardNumber).then((result) => {
        if (result.valid && result.data) {
          setResult({
            name: result.data.customer_name,
            customer_id: result.data.customer_id,
            customer_group: result.data.customer_group,
            customer_group_id: result.data.customer_group_id,
            birthdate: result.data.birthdate,
            card_number: result.data.card_number,
            medicare_card: result.data.medicare_cardNum,
            ask_for_telephone: result.data.ask_for_telephone
          });
          customer = result.data;
          setLoad(false);
          viewDiscountList(result.data.customer_id, result.data.medicare_cardNum);
        } else {
          // Toast.fail(result.error, 3000);
          setLoad(false);
        }
      }, () => {
        // Toast.fail('Ocorreu um erro.', 3000);
        setLoad(false);
      });
    } else {
      setLoad(false);
      // Toast.info("Campo Obrigatório", 3000);
    }
  }

  function captureQrClick(e, type = 1) {
    e.preventDefault();
    if (type === 1)
      setModalShow(true);
    if (type === 2)
      setModalShow2(true);
  }

  function confirmOffers(e) {
    e.preventDefault();

    if (!amounts.amount_with_discount || !amounts.amount_without_discount) {
      setAlertModal(true);
    } else {
      use_offer();
    }
  }

  function use_offer(e = null) {
    if (e) { e.preventDefault(); }
    if (offersChecked.length > 0) {
      setLoad(true);
      let data = {
        location_id: Number(user.location_id),
        customer_id: Number(result.customer_id),
        medicare_cardNum: Number(result.medicare_card),
        amount_with_discount: amounts.amount_with_discount ? Number(amounts.amount_with_discount) : 0,
        amount_without_discount: amounts.amount_without_discount ? Number(amounts.amount_without_discount) : 0,
        offers: []
      };
      for (var i = 0; i <= offersChecked.length; i++) {
        if (offersChecked[i]) {
          const offer = {
            offer_id: Number(offersChecked[i].offer_id),
            customer_id: Number(result.customer_id),
            location_id: Number(user.location_id),
            customer_group_id: Number(result.customer_group_id),
            medicare_cardNum: Number(result.medicare_card),
          };
          data.offers.push(offer);
        } else {
          // Chamar Metodo e Fazer teste
          OffersService.use_offer(user.token, data).then((result) => {
            setLoad(false);

            if (result.offers_error > 0) {
              // setTimeout(() => {
              if (result.offers_error === 1) {
                Toast.fail('O desconto não foi utilizado.', 3000);
              } else {
                Toast.fail('Os ' + result.offers_error + ' descontos não foram utilizados.', 3000);
              }
              // }, 3000);
            } else {
              Toast.success(result.offers_sucess + ' desconto(s) utilizado(s) com sucesso.', 3000);
            }
            onClear();
          }, (err) => {
            setLoad(false);
            Toast.fail(err.error, 3000);
          });
        }
      }
    } else {
      Toast.fail('Seleccione uma Oferta', 3000);
    }
  }

  function viewDiscountList(customer_id, medicare_cardNum) {
    setLoad(true);
    OffersService.location_offers(user.token, user.location_id, customer_id, medicare_cardNum).then((result) => {
      if (result.total > 0) {
        setOffers(result.offers);
        setLoad(false);
      } else {
        Toast.info('Nenhuma Oferta Disponível.', 3000);
        setLoad(false);
      }
    });
  }

  function organize_date(date) {
    if (date) {
      const d = date.split('-');
      return d[2] + '/' + d[1] + '/' + d[0];
    } else {
      return "XX/XX/XXXX";
    }
  }

  function onClear(text = true) {
    setResult(null);
    customer = null;
    if (text) {
      setData({
        phone_number: "",
        card_number: ""
      });
    }

    setOffersChecked([]);

    setAmounts({
      amount_with_discount: "",
      amount_without_discount: ""
    });
  }


  return (
    <HomePage>
      <Menu locations={true} page="home" />
      <HomeContent>
        <div className="pageTitle"><FiGrid />Validar Desconto</div>
        <Modal
          show={alerModal}
          centered
          size="sm"
          onHide={() => { setAlertModal(false); }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Pretende submeter com os valores dos totais da conta a zero ?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => { setAlertModal(false); }}>Não</Button>
            <Button variant="primary" onClick={(e) => { setAlertModal(false); use_offer(e) }}>Sim</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={load}
          onHide={() => setLoad(true)}
          className="trasnp"
        >
          <Modal.Body>
            <Spinner animation="border" role="status" style={{ color: 'white' }}>
            </Spinner>
            <span className="sr-only">Loading...</span>
          </Modal.Body>
        </Modal>


        {result ?
          <HomeBody>
            <Result id="cardSection">
              {/* {result.ask_for_telephone === 1 ?
                  <ResultInfo style={{textAlign: "center"}}>
                    <ButtonClear onClick={()=> onClear()}><FaTrash /></ButtonClear>
                    <div className="name">{result.name}</div>
                    <div className="member2">
                      <span>Membro {result.customer_group}</span>
                    </div>
                    <br />
                    <span className="notMember">Membro não registrado em medicareclub.ao</span>
                    <br />
                    <span className="info">Peça o número de telefone ao cliente</span>
                    <InputGroup className="mb-3">
                      <FormControl
                        placeholder="Insira número de telefone"
                        type="text" 
                        value={phoneNumber}
                        onChange={(e)=> setPhoneNumber(e.target.value)}
                      />
                      <InputGroup.Append>
                        <Button 
                          className="btn-camera"
                          onClick={(e) => setCustomerNumber(e)}
                        >
                          <FaAngleRight />
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                  </ResultInfo>
                :  */}
              <ResultInfo
                style={{ background: result.customer_group_id === "1" ? 'url("https://medicareclub.ao/catalog/view/theme/default/image/card-base-bg.jpg")' : 'url("https://medicareclub.ao/catalog/view/theme/default/image/card-bg-exclusive-1.jpg")' }}
              >
                <ButtonClear onClick={() => onClear()}><FaTrash /></ButtonClear>
                <img className="logo" src={logo} alt="Medicare club" />
                <div className="name">{result.name}</div>
                <div className="club-number">{result.card_number ? result.card_number : 'XXXXXXXXXXXX'}</div>
                <div className="data">Data de Nascimento: {organize_date(result.birthdate)}</div>
                <div className="member"
                  style={{
                    backgroundColor: result.customer_group_id === "1" ? '#bf2f38' : '#D4AF34',
                    color: result.customer_group_id === "1" ? '#fff' : '#000'
                  }}>
                  <span>Membro </span>{result.customer_group}
                </div>
              </ResultInfo>
              {/*  } */}
              <h3 className="title">DESCONTOS E OFERTAS</h3>
              <Accordion activeKey={aActived} className="myAccordion" style={{ marginBottom: "15px" }}>
                {listItems}
              </Accordion>
              <div className="discounts-footer" style={{ justifyContent: "space-between" }}>
                <Accordion defaultActiveKey="0">
                  <div className="_form">
                    <Accordion.Collapse eventKey="1" style={{ width: "100%" }}>
                      <div>
                        <div className="_input">
                          <Form.Control type="number" value={amounts.amount_without_discount}
                            onChange={(e) => setAmounts({ ...amounts, amount_without_discount: e.target.value })} placeholder="Total Conta" />
                        </div>
                        <div className="_input">
                          <Form.Control type="number" value={amounts.amount_with_discount}
                            onChange={(e) => setAmounts({ ...amounts, amount_with_discount: e.target.value })} placeholder="Total com Desconto" />
                        </div>
                      </div>
                    </Accordion.Collapse>
                    <div className="_buttons">
                      <Accordion.Toggle as={Button} size="lg" style={{ width: "20%" }} eventKey="1">
                        <FaReceipt />
                      </Accordion.Toggle>
                      <Button style={{ width: "78%" }}
                        disabled={offersChecked.length > 0 ? false : true}
                        variant="success" size="lg" onClick={(e) => confirmOffers(e)}>
                        CONFIRMAR <Badge variant="light">{offersChecked.length}</Badge>
                      </Button>
                    </div>
                  </div>
                </Accordion>
              </div>
            </Result>
          </HomeBody>
          :
          <Search id="searchSection">
            <label className="label-1">Para verificar a subscrição</label>
            <label className="label-2">Preencha um dos campos</label>

            <Modal
              show={modalShow}
              onHide={() => setModalShow(false)}
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Capturar Código QR
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <QrReader
                  delay={300}
                  onError={() => setModalShow(false)}
                  onScan={(data) => {
                    if (data) {
                      setModalShow(false);
                      searchClick(null, data);
                    }
                  }}
                  style={{ width: '100%' }}
                />
              </Modal.Body>
            </Modal>




            {/* <label className="label-1">TELEFONE</label>
                <InputGroup className="mb-3">
                  <FormControl
                    placeholder="ex: 944007610"
                    name="phone_number" 
                    id="phone_number" 
                    type="number" 
                    value={data.phone_number} 
                    onChange={(e)=> dataChange(e)}
                  />
                </InputGroup> */}


            <label className="label-1" style={{ fontWeight: 'bold' }}>CARTÃO MEDICARE SAÚDE - MEDICARE CLUB</label>
            <div className="text-container">
              {/* <div className='text-empty'></div> */}
              <div style={{ flexGrow: '8' }}>
                <InputGroup className="mb-3">
                  <FormControl
                    placeholder="ex: 222 6721 6353"
                    name="card_number"
                    id="card_number"
                    type="number"
                    value={cardNumber}
                    onChange={(e) =>setCardNumber(e.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        searchClick(event);
                      }
                    }}
                  />
                  <InputGroup.Append>
                    <Button
                      className="btn-camera"
                      onClick={(e) => captureQrClick(e, 2)}
                    >
                      <FaCamera />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>

              </div>
              <div style={{
                display:'flex',
                flexDirection:'column'
              }}>
                <img src={medicareCardsImg} style={{ objectFit:'contain',width: '150px',height:'100px',  }} />
                <img src={clubCardsImg} style={{objectFit:'contain', width: '150px',height:'100px',  }} />
              </div>
              {/*                  
 */}                </div>

            <ButtonSearch
              disabled={cardNumber ? false : true}
              onClick={(e) => searchClick(e)}
            >
              VER DESCONTOS DISPONÍVEIS
            </ButtonSearch>

            <div className='help-center'>
              <FaHeadset size={45} color='#9F3636' />
              <div class="header-contact-detail">
                <span>Precisa de ajuda?</span>
                <br />
                <span style={{ fontSize: '20px' }}>923 167 140</span>
              </div>
            </div>
          </Search>
        }

      </HomeContent>
    </HomePage>
  );
}

export default Home;

